module.exports = __webpack_public_path__ + "static/avatar-3a447ee72c0ffad387bdab373bb0f633.png";